import { Host, h } from '@stencil/core';
export class AibaIcon {
  constructor() {
    this.handlers = undefined;
    this.url = undefined;
    this._id = undefined;
    this.altText = undefined;
    this.handleClick = undefined;
    this.imgProps = undefined;
  }
  // handleClick(event): void {
  //   this.handlers && this.handlers?.handleClickIcon(event);
  // }
  render() {
    return (h(Host, { id: this._id ? this._id : '' }, h("span", { onClick: event => this.handleClick && this.handleClick(event), class: "aiba-icon" }, h("img", Object.assign({}, this.imgProps, { src: this.url, alt: this.altText })))));
  }
  static get is() { return "aiba-icon"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-icon.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-icon.css"]
    };
  }
  static get properties() {
    return {
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "url": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "url",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "altText": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "alt-text",
        "reflect": false
      },
      "handleClick": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handle-click",
        "reflect": false
      },
      "imgProps": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "img-props",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-icon.js.map
